<template>
    <div :class="selfPrefix">
        <section-title text="联系我们"/>

        <div
            :class="`${selfPrefix}-form`">
            <div
                :key="index + 'form'"
                :class="`${selfPrefix}-form-item`"
                v-for="(item, index) in dataList">
                <div :class="`${selfPrefix}-form-item-label`">{{item.title}}：</div>
                <div :class="`${selfPrefix}-form-item-content`">
                    <j-input
                        v-if="item.typeInput != 'textarea'"
                        @on-blur="checkField(index)"
                        :placeholder="item.placeholder"
                        size="large"
                        length="long"
                        v-model="formObj[item.keyName]"/>
                    <j-input
                        v-else
                        type="textarea"
                        :placeholder="item.placeholder"
                        @on-blur="checkField(index)"
                        length="long"
                        :rows="{min: 6, max: 6}"
                        v-model="formObj[item.keyName]"/>
                    <div class="error-info">
                        {{item.error}}
                    </div>
                </div>
            </div>

            <div :class="`${selfPrefix}-form-btn`">
                <cloud-button text="立即咨询" :handleClick="send"></cloud-button>
            </div>
        </div>
    </div>
</template>

<script>
import sectionTitle from "../../components/sectionTitle";
import cloudButton from "../../components/cloudButton";
import { sendEmail } from "../../api/index.js";
export default {
  name: "ContactUs",
  components: {
    sectionTitle: sectionTitle,
    cloudButton: cloudButton
  },
  data() {
    return {
      prefixCls: "jad-block",
      dataList: [
        {
          title: "公司名称",
          typeInput: "text",
          placeholder: "请输入公司全称",
          require: true,
          rule: "",
          keyName: "companyName"
        },
        {
          keyName: "contactPerson",
          placeholder: "请输入联系人姓名",
          title: "联系人",
          require: true,
          rule: "",
          typeInput: "text"
        },
        {
          keyName: "contactPhone",
          placeholder: "请输入联系人手机号码",
          require: true,
          rule: "^1\\d{10}$",
          title: "联系电话",
          typeInput: "text"
        },
        {
          keyName: "consultProducts",
          placeholder: "可选择“商智、数坊、京东消息类产品、营销云-天链/会员通/全域监测/RTA/内容营销、京洞察|新品孵化中心等，可多选",
          require: true,
          rule: "",
          title: "意向合作产品",
          typeInput: "textarea"
        },
        {
          keyName: "consultProblem",
          placeholder: "请输入您的业务需求，如业务场景目标、业务痛点、生态合作意向等",
          require: true,
          rule: "",
          title: "业务合作方向",
          typeInput: "textarea"
        }
      ],
      formObj: {},
      rules: {},
      mailApi: {
        dataSourceParams: {
          html:
            "公司名称：{{companyName}}\\r\\n 联系人：{{contactPerson}}\\r\\n 联系电话：{{contactPhone}} \\r\\n 咨询产品：{{consultProducts}}\\r\\n 咨询问题：{{consultProblem}}",
          subject: "营销云联系我们意见"
        }
      }
    };
  },
  computed: {
    selfPrefix() {
      return `${this.prefixCls}-contact-us`;
    }
  },
  methods: {
    init() {
      this.dataList.forEach(item => {
        this.formObj[item.keyName] = "";
      });
    },
    checkField(idx) {
      this.dataList = this.dataList.map((item, index) => {
        if (idx === index) {
          item.error = "";
          let value = this.formObj[item.keyName];
          if (item.require && !value) {
            item.error = `请填写${item.title}`;
          }
          if (value && item.rule && !new RegExp(item.rule).test(value)) {
            item.error = `请填写正确${item.title}`;
          }
        }
        return item;
      });
    },
    checkAll() {
      this.dataList = this.dataList.map(item => {
        item.error = "";
        let value = this.formObj[item.keyName];
        if (item.require && !value) {
          item.error = `请填写${item.title}`;
        }
        if (value && item.rule && !new RegExp(item.rule).test(value)) {
          item.error = `请填写正确${item.title}`;
        }
        return item;
      });
    },
    send() {
      this.checkAll();
      let obj = this.dataList.find(item => !!item.error);
      if (obj) {
        this.$Notification["error"]({
          message: obj.error
        });
        return;
      }
      sendEmail(this.formObj)
        .then((res) => {
          if(res.code == 1){
            this.$Notification["success"]({
                message: "发送成功"
            });
            this.init();
          }else{
            this.$Notification["success"]({
                message: "发送失败"
            });
          }
        })
        .catch(() => {
          this.$Notification["error"]({
            message: "发送失败"
          });
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.jad-block-contact-us {
    text-align: center;
    margin: 0 auto;
    padding: 50px;
    background: linear-gradient(180deg, #f0f2ff 0%, #fbfcff 48.13%, white 100%);
  &-title {
    position: relative;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 229px;
    height: 45px;
    font-size: 32px;
    font-family: PingFangSC;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    // background: url(//img11.360buyimg.com/img/jfs/t1/205786/11/6927/321/61445392Ebc85b610/5291a6aebc8c836b.png)
    //   no-repeat center center;
  }

  &-form {
    display: inline-block;
    margin-top: 10px;

    &-item {
      display: flex;
      justify-content: space-between;
      margin-top: 44px;
      &-label {
        width: 120px;
        height: 40px;
        text-align: right;
        line-height: 40px;
        font-size: 16px;
        font-family: PingFangSC;
        font-weight: 500;
        color: #626262;
        margin-right: 16px;
      }

      &-content {
        position: relative;
        .error-info {
          position: absolute;
          font-size: 12px;
          text-align: left;
          color: #3247ff;
          margin-top: 8px;
        }
      }
    }

    &-btn {
      text-align: left;
      margin-left: 106px;
      margin-top: 60px;
    }
  }
}
</style>